<template>
  <div class="l3">
    <a class="skip" href="#main">Saltar al contenido</a>
    <main id="main">
      <section class="hero wrap" aria-labelledby="hero-title">
        <div class="hero-copy">
          <div class="eyebrow">Consultas / del primer hola al presupuesto</div>
          <h1 v-if="isCopyV2" id="hero-title">
            Que ninguna consulta<br />quede perdida<br />
            <span class="accent">entre mensajes.</span>
          </h1>
          <h1 v-else id="hero-title">
            Todos los<br />“¿cuánto sale?”<br />que no contestaste<br />
            <span class="accent">eran plata.</span>
          </h1>
          <p v-if="isCopyV2">
            Compartís tu link por WhatsApp, Instagram o donde te contacten. Las consultas que
            llegan por ese formulario quedan organizadas en Prio, con un análisis privado para
            que prepares el presupuesto y decidas cuándo compartirlo.
          </p>
          <p v-else>
            No te faltan interesados. Te falta llegar a todos.<br />Tu link con tu marca recibe
            consultas las 24 horas. Después del envío, la IA prepara un análisis para que vos
            revises y presupuestes.
          </p>
          <a class="cta" :href="SIGNUP_URL"
            >Probá gratis 30 días <span aria-hidden="true">↗</span>
          </a>
          <div class="guarantee">Sin tarjeta</div>
        </div>
        <div class="hero-art">
          <div id="hero-scene" class="scene" :data-view="heroAnalyzed ? 'analyzed' : 'raw'">
            <span class="handnote" aria-hidden="true">Vos ya habías cerrado. ↘</span>
            <span class="spark" aria-hidden="true">✳</span>
            <div class="raw-message">
              <strong>“Somos 8, queremos city tour 2 días…</strong> y traslado del aeropuerto. Vamos
              la semana que viene. ¿Cuánto sale?”<small>Juli · 23:12</small>
            </div>
            <div class="connector">
              <span aria-hidden="true">↓</span>
              <span v-if="isCopyV2" class="mono">MISMA CONSULTA. LISTA PARA REVISAR.</span>
              <span v-else class="mono">MISMA CONSULTA. YA LEÍDA.</span>
            </div>
            <div id="hero-result" class="sheet hero-sheet arrive" :aria-hidden="!heroAnalyzed">
              <div class="sheet-top">
                <span class="studio">sur tours</span>
                <span class="status high">Prioridad alta</span>
              </div>
              <div class="sheet-title">Juli quiere conocer<br />Buenos Aires.</div>
              <div class="chips">
                <span class="chip">City tour · 2 días</span>
                <span class="chip">Traslado · 8 personas</span>
              </div>
              <div class="total">
                <span>Estimado</span>
                <strong>$885.000</strong>
              </div>
              <div class="footnote">Vista del profesional · Estimado de ejemplo para revisar.</div>
            </div>
          </div>
          <div class="hero-controls">
            <button
              class="quiet-button"
              id="hero-toggle"
              type="button"
              data-action="hero-view-toggle"
              aria-controls="hero-result"
              :aria-expanded="heroAnalyzed"
              @click="toggleHero"
            >
              {{ heroAnalyzed ? '↺ Ver el mensaje sin analizar' : isCopyV2 ? '✦ Ver la consulta organizada' : '✦ Ver la consulta leída' }}
            </button>
          </div>
          <p class="demo-caption">Ejemplo ilustrativo · Tu catálogo, tus importes.</p>
        </div>
      </section>
      <div class="ribbon">
        <span aria-hidden="true">✳</span> Que llegue tarde. No que se pierda.
        <span aria-hidden="true">✳</span>
        <b class="desktop">Tu link abierto. Vos con tu vida.</b>
      </div>
      <section class="section wrap" aria-labelledby="pain-title">
        <div class="eyebrow">El problema no es tu memoria</div>
        <div class="pain-heading reveal">
          <h2 v-if="isCopyV2" id="pain-title">
            Todas tus consultas,<br />
            <span class="accent">en una bandeja.</span>
          </h2>
          <h2 v-else id="pain-title">
            Hoy tus consultas viven en WhatsApp.<br />
            <span class="accent">Abajo de los memes.</span>
          </h2>
          <p>
            Un “¿cuánto sale?”, dos audios, el grupo de amigos. Cuando volvés a buscar la consulta,
            ya pasó el día. Y capaz el cliente también.
          </p>
        </div>
        <div class="stats reveal">
          <div class="stat">
            <div class="stat-number" aria-label="24/7">
              <span id="count" ref="countRef" aria-hidden="true">24</span>
              <span aria-hidden="true">/7</span>
            </div>
            <div>
              <b>Tu link trabaja.</b>
              <p>La de las 23:12 no espera<br />a que vuelvas a abrir WhatsApp.</p>
            </div>
          </div>
          <div class="stat">
            <div class="stat-number">→</div>
            <div>
              <b>De consulta a una base.</b>
              <p>Menos transcripción.<br />Más tiempo para revisar.</p>
            </div>
          </div>
          <div class="stat">
            <div class="stat-number">Vos</div>
            <div>
              <b>Decidís cómo responder.</b>
              <p>Que el tiempo se vaya en decidir.<br />No en descifrar el mensaje.</p>
            </div>
          </div>
        </div>
      </section>
      <section class="section flow" id="como-funciona" aria-labelledby="flow-title">
        <div class="wrap">
          <div class="eyebrow">Un link. Cuatro pasos menos en tu cabeza.</div>
          <div class="flow-head reveal">
            <h2 id="flow-title">Del “hola, ¿cuánto?”<br />al “ya lo tengo”.</h2>
            <p>Tu cliente te cuenta qué necesita.<br />Prio ordena. Vos decidís cómo seguir.</p>
          </div>
          <div class="steps">
            <article class="step" id="link">
              <div class="step-copy reveal">
                <div class="step-number">01 / DONDE YA TE BUSCAN</div>
                <h3>Un solo link.<br />En todos tus “hola”.</h3>
                <p>
                  En la bio de Instagram, una respuesta rápida de WhatsApp, el botón de tu web o tu
                  firma de mail. Siempre la misma dirección: <strong>prio.ar/u/tu-negocio</strong>.
                </p>
                <p>
                  La ponés una vez. Cada consulta tiene por dónde entrar, sin que vos tengas que
                  estar.
                </p>
                <span class="step-aside">Tu marca en la puerta. Siempre. ↗</span>
              </div>
              <div class="mock-shell reveal">
                <div class="mock-label">
                  <span>EL MISMO LINK, CUATRO LUGARES</span>
                  <span>PROBALO ↓</span>
                </div>
                <div class="switcher" role="group" aria-label="Dónde compartir tu link">
                  <button
                    type="button"
                    data-action="placement-switch"
                    data-context="ig"
                    :aria-pressed="placement === 'ig'"
                    aria-controls="place-ig"
                    data-placement="ig"
                    @click="setPlacement('ig')"
                  >
                    Instagram
                  </button>
                  <button
                    type="button"
                    data-action="placement-switch"
                    data-context="wa"
                    :aria-pressed="placement === 'wa'"
                    aria-controls="place-wa"
                    data-placement="wa"
                    @click="setPlacement('wa')"
                  >
                    WhatsApp
                  </button>
                  <button
                    type="button"
                    data-action="placement-switch"
                    data-context="web"
                    :aria-pressed="placement === 'web'"
                    aria-controls="place-web"
                    data-placement="web"
                    @click="setPlacement('web')"
                  >
                    Tu web
                  </button>
                  <button
                    type="button"
                    data-action="placement-switch"
                    data-context="mail"
                    :aria-pressed="placement === 'mail'"
                    aria-controls="place-mail"
                    data-placement="mail"
                    @click="setPlacement('mail')"
                  >
                    Mail
                  </button>
                </div>
                <div id="place-ig" class="placement arrive" :hidden="placement !== 'ig'">
                  <div class="placement-head">
                    <b>surtours.ba</b>
                    <span aria-hidden="true">···</span>
                  </div>
                  <div class="placement-body">
                    <div class="profile">
                      <span class="avatar" aria-hidden="true">s.</span>
                      <div>
                        <strong>sur tours</strong>
                        <small>Buenos Aires, a tu ritmo.</small>
                      </div>
                    </div>
                    <p>Recorridos privados y traslados.<br />Contanos qué viaje tenés en mente ↓</p>
                    <a class="linkpill" href="#formulario">↗ prio.ar/u/sur-tours</a>
                  </div>
                </div>
                <div id="place-wa" class="placement wa arrive" :hidden="placement !== 'wa'">
                  <div class="placement-head">
                    <b>WhatsApp / Juli</b>
                    <span>23:12</span>
                  </div>
                  <div class="placement-body">
                    <div class="shortcut">Respuesta rápida: /presupuesto</div>
                    <div class="bubble">
                      ¡Hola! Contame qué necesitás por acá y te preparo un presupuesto.<br />
                      <a class="linkpill" href="#formulario">↗ prio.ar/u/sur-tours</a>
                      <small>23:13 ✓✓</small>
                    </div>
                  </div>
                </div>
                <div
                  id="place-web"
                  class="placement web-preview arrive"
                  :hidden="placement !== 'web'"
                >
                  <div class="placement-head">
                    <span>surtours.com.ar</span>
                    <span aria-hidden="true">☰</span>
                  </div>
                  <div class="placement-body">
                    <span class="studio">sur tours</span>
                    <h4>La ciudad tiene historias.<br />Vení a buscar la tuya.</h4>
                    <a class="linkpill" href="#formulario">Pedí tu presupuesto ↗</a>
                    <p class="footnote">prio.ar/u/sur-tours</p>
                  </div>
                </div>
                <div id="place-mail" class="placement arrive" :hidden="placement !== 'mail'">
                  <div class="placement-head">
                    <b>Mail / firma</b>
                    <span>Para: Juli</span>
                  </div>
                  <div class="placement-body">
                    <div class="email-lines" aria-hidden="true"></div>
                    <div class="email-lines short" aria-hidden="true"></div>
                    <div class="signature">
                      <strong>Clara · sur tours</strong>
                      <p>Buenos Aires, a tu ritmo.<br />¿Armamos tu recorrido?</p>
                      <a class="linkpill" href="#formulario">↗ prio.ar/u/sur-tours</a>
                    </div>
                  </div>
                </div>
                <p id="placement-note" class="placement-note" role="status">{{ placementNote }}</p>
              </div>
            </article>
            <article class="step" id="formulario">
              <div class="step-copy reveal">
                <div class="step-number">02 / CON SUS PALABRAS</div>
                <h3>Que te cuente el plan.<br />No que adivine<br />tu catálogo.</h3>
                <p>
                  Un formulario profesional, con tu logo. Tu cliente
                  <strong>te cuenta qué necesita</strong> como le sale. No tiene que saber cómo se
                  llama tu servicio.
                </p>
                <p>
                  Si falta contexto, la IA puede hacer
                  <strong>hasta dos preguntas abiertas antes de enviar</strong>. Responder es
                  opcional. Si el pedido ya es claro, se envía sin preguntas.
                </p>
                <span class="step-aside">Sin elegir paquetes ni conocer tu catálogo.</span>
              </div>
              <div class="mock-shell reveal">
                <div class="mock-label">
                  <span>LO QUE VE TU CLIENTE</span>
                  <span>TU MARCA</span>
                </div>
                <div class="sheet form-sheet" data-context="lead-form-preview">
                  <div class="sheet-top">
                    <span class="studio">sur tours</span>
                    <span class="mono">CONSULTAS</span>
                  </div>
                  <div class="sheet-title">Enviá tu<br />consulta.</div>
                  <p style="font-size: 11px">
                    Tu nombre, un contacto y lo que necesitás. La dirección es opcional.
                  </p>
                  <div class="field"><small>NOMBRE</small>Juli</div>
                  <div class="field">
                    <small>CONTACTO · EMAIL O TELÉFONO</small>juli@example.com
                  </div>
                  <div class="field"><small>DIRECCIÓN · OPCIONAL</small>Sin completar</div>
                  <div class="field">
                    <small>¿QUÉ NECESITÁS?</small>Somos 8, queremos city tour 2 días y traslado del
                    aeropuerto. Vamos la semana que viene.
                  </div>
                  <div class="clarify">
                    <strong>✦ Aclaración opcional · Ejemplo</strong>
                    <p>¿Para qué fechas necesitás el recorrido y el traslado?</p>
                    <div class="answer">
                      Llegamos a Ezeiza el 21 de octubre. Queremos recorrer el 22 y el 23.
                    </div>
                  </div>
                  <div class="form-end" :hidden="formSent !== null">
                    <button type="button" data-action="lead-send-answers" @click="formSent = true">
                      Enviar con respuestas ↗
                    </button>
                    <button type="button" data-action="lead-send-skip" @click="formSent = false">
                      Enviar sin responder
                    </button>
                  </div>
                  <p class="footnote" role="status" :hidden="formSent === null">
                    Consulta enviada{{
                      formSent ? ' con la aclaración' : ' sin responder la aclaración'
                    }}. Simulación: no se guardó nada.
                  </p>
                  <button
                    v-if="formSent !== null"
                    type="button"
                    class="quiet-button"
                    data-action="lead-form-reset"
                    @click="formSent = null"
                  >
                    Reiniciar ejemplo
                  </button>
                  <p v-if="!isCopyV2" class="footnote">
                    Si la IA no responde, la consulta se envía igual. No accede a tu catálogo en
                    este paso.
                  </p>
                </div>
              </div>
            </article>
            <article class="step" id="analisis">
              <div class="step-copy reveal">
                <div class="step-number">03 / EL CHOCLO, LEÍDO</div>
                <h3>No te llega más texto.<br />Te llega una base.</h3>
                <p>
                  Después del envío, la IA cruza la consulta con tu catálogo y presupuestos
                  anteriores:
                  <strong>servicios sugeridos, un estimado y la prioridad</strong>. Ese choclo de
                  texto ya tiene forma.
                </p>
                <p>
                  Si el cliente respondió las preguntas opcionales, también ves esas aclaraciones.
                  Vos revisás el análisis y decidís cómo seguir.
                </p>
                <span class="step-aside">No es magia. Es tu catálogo. ↗</span>
              </div>
              <div class="mock-shell reveal">
                <div class="mock-label">
                  <span>LO QUE RECIBÍS VOS</span>
                  <span>DEMO INTERACTIVA</span>
                </div>
                <div class="sheet">
                  <div class="sheet-top">
                    <strong>Consulta de Juli</strong>
                    <span id="analysis-status" class="status">{{
                      analysisOpen ? 'Analizada' : 'Sin analizar'
                    }}</span>
                  </div>
                  <div class="analysis-raw">
                    “Somos 8, queremos city tour 2 días y traslado del aeropuerto. Vamos la semana
                    que viene.”
                  </div>
                  <button
                    id="analysis-toggle"
                    class="analysis-button"
                    type="button"
                    data-action="analysis-toggle"
                    :aria-expanded="analysisOpen"
                    aria-controls="analysis-result"
                    @click="toggleAnalysis"
                  >
                    {{ analysisOpen ? '↺ Volver al mensaje original' : isCopyV2 ? '✦ Ver cómo queda organizada' : '✦ Ver cómo entra leída' }}
                  </button>
                  <div id="analysis-result" class="analysis-result arrive" :hidden="!analysisOpen">
                    <div class="chips">
                      <span class="chip">City tour privado</span>
                      <span class="chip">Traslado aeropuerto</span>
                      <span class="status high">Prioridad alta</span>
                    </div>
                    <div class="catalog-row">
                      <span>City tour · 2 × $360.000</span>
                      <b>$720.000</b>
                    </div>
                    <div class="catalog-row">
                      <span>Traslado · grupo de 8</span>
                      <b>$165.000</b>
                    </div>
                    <div class="total">
                      <span>Estimado</span>
                      <strong>$885.000</strong>
                    </div>
                    <div class="suggestion">
                      <b>✦ Aclaración del cliente · Ejemplo con respuesta</b>Llegamos a Ezeiza el 21
                      de octubre. Queremos recorrer el 22 y el 23.
                    </div>
                    <p class="footnote">
                      Precios de catálogo ilustrativos. Revisás los datos antes de presupuestar.
                    </p>
                  </div>
                </div>
              </div>
            </article>
            <article class="step" id="bandeja">
              <div class="step-copy reveal">
                <div class="step-number">04 / DE CONSULTA A PRESUPUESTO</div>
                <h3 v-if="isCopyV2">Un clic.<br />Y ya no arrancás<br />de cero.</h3>
                <h3 v-else>Un click.<br />Y ya no arrancás<br />de cero.</h3>
                <p>
                  Nueva, analizada, contactada o convertida. Cada consulta en su estado, no perdida
                  entre conversaciones.
                </p>
                <p>
                  <strong>Crear presupuesto</strong> usa la consulta como base. Revisás y guardás el
                  borrador antes de compartir. ¿Preferís hablar primero? Usá el
                  <strong>email o teléfono</strong> que dejó el cliente.
                </p>
                <span class="step-aside">Probá convertir la de Juli. ↗</span>
              </div>
              <div class="mock-shell inbox reveal">
                <div class="mock-label">
                  <span>{{ isCopyV2 ? 'TU BANDEJA, EN ORDEN' : 'TU BANDEJA, SIN MEMES' }}</span>
                  <span>PROBALO ↓</span>
                </div>
                <div class="sheet">
                  <div class="sheet-top">
                    <span class="inbox-title">Consultas</span>
                    <span class="mono">SUR TOURS</span>
                  </div>
                  <div class="filters" role="group" aria-label="Filtrar consultas por estado">
                    <button
                      type="button"
                      data-filter="all"
                      :aria-pressed="filter === 'all'"
                      @click="setFilter('all')"
                    >
                      Todas
                    </button>
                    <button
                      type="button"
                      data-filter="new"
                      :aria-pressed="filter === 'new'"
                      @click="setFilter('new')"
                    >
                      Nueva
                    </button>
                    <button
                      type="button"
                      data-filter="analyzed"
                      :aria-pressed="filter === 'analyzed'"
                      @click="setFilter('analyzed')"
                    >
                      Analizada
                    </button>
                    <button
                      type="button"
                      data-filter="contact"
                      :aria-pressed="filter === 'contact'"
                      @click="setFilter('contact')"
                    >
                      Contactada
                    </button>
                    <button
                      type="button"
                      data-filter="converted"
                      :aria-pressed="filter === 'converted'"
                      @click="setFilter('converted')"
                    >
                      Convertida
                    </button>
                  </div>
                  <div id="inbox-rows">
                    <article
                      v-for="row in rows"
                      :key="row.name"
                      class="inbox-row"
                      :data-state="row.state"
                      :data-name="row.name"
                      :hidden="filter !== 'all' && row.state !== filter"
                    >
                      <div class="row-head">
                        <strong>{{ row.title }}</strong>
                        <span class="status row-status" :class="stateClass(row.state)">{{
                          stateLabel(row.state)
                        }}</span>
                      </div>
                      <p>{{ row.detail }}</p>
                      <div class="row-actions">
                        <button
                          type="button"
                          data-action="convert"
                          :data-context="row.name"
                          :disabled="row.convertDisabled"
                          :aria-label="'Simular creación de borrador para ' + row.name"
                          @click="convertRow(row)"
                        >
                          {{
                            row.convertDisabled
                              ? '✓ Borrador creado'
                              : '✦ Simular creación de borrador'
                          }}
                        </button>
                        <button
                          type="button"
                          data-action="contact"
                          :data-context="row.name"
                          :aria-label="'Simular contacto con ' + row.name"
                          @click="contactRow(row)"
                        >
                          Contactar ↗
                        </button>
                      </div>
                    </article>
                  </div>
                  <p id="empty" class="empty" :hidden="visibleCount > 0">
                    No hay consultas en este estado.
                  </p>
                  <div id="draft" class="draft arrive" :hidden="!draftVisible">
                    <b id="draft-title">{{ draftTitle }}</b>
                    <p id="draft-copy">{{ draftCopy }}</p>
                    <p>Nada enviado. Falta tu revisión.</p>
                  </div>
                  <p id="inbox-feedback" class="inbox-feedback" role="status">
                    {{ inboxFeedback }}
                  </p>
                  <button
                    id="reset-inbox"
                    class="quiet-button"
                    type="button"
                    data-action="inbox-reset"
                    @click="resetInbox"
                  >
                    ↺ Reiniciar demo
                  </button>
                </div>
              </div>
            </article>
          </div>
        </div>
      </section>
      <section class="section wrap" id="copiloto" aria-labelledby="trust-title">
        <div class="eyebrow">Inteligencia que acompaña</div>
        <div class="trust-head reveal">
          <h2 id="trust-title">
            Es tu copiloto.<br />
            <span class="accent">No tu reemplazo.</span>
          </h2>
          <div class="seal" aria-hidden="true">Tu criterio.<br />Siempre.</div>
        </div>
        <div class="compare reveal">
          <div class="compare-col">
            <h3>LO QUE HACE</h3>
            <ul v-if="isCopyV2">
              <li>Lee la consulta que llega por tu link.</li>
              <li>Usa tu catálogo e historial como referencia.</li>
              <li>Puede pedir hasta dos aclaraciones opcionales antes del envío.</li>
              <li>Preparás el presupuesto y decidís cuándo compartirlo.</li>
            </ul>
            <ul v-else>
              <li>Lee la consulta y detecta servicios.</li>
              <li>Usa tu catálogo e historial como referencia.</li>
              <li>Puede pedir aclaraciones opcionales antes del envío.</li>
              <li>Prepara un análisis para que revises.</li>
            </ul>
          </div>
          <div class="compare-col">
            <h3>LO QUE NO HACE</h3>
            <ul v-if="isCopyV2">
              <li>No comparte presupuestos sin tu revisión.</li>
              <li>No decide precios ni condiciones por vos.</li>
              <li>No es un chatbot.</li>
              <li>No reemplaza tu criterio.</li>
            </ul>
            <ul v-else>
              <li>No responde por vos.</li>
              <li>No manda sin aprobación.</li>
              <li>No es un chatbot.</li>
              <li>No reemplaza tu criterio.</li>
            </ul>
          </div>
        </div>
        <p class="trust-bottom reveal">
          La IA aclara el pedido dentro del formulario. La conversación con tu cliente sigue siendo
          tuya.
        </p>
      </section>
      <section class="closing" aria-labelledby="closing-title">
        <div class="wrap reveal">
          <div class="eyebrow">La de las 23:12 también cuenta</div>
          <h2 id="closing-title">
            La próxima consulta<br />puede entrar esta noche.<br />
            <span>{{ isCopyV2 ? 'Y entrar organizada.' : 'Y entrar leída.' }}</span>
          </h2>
          <p>No hace falta que estés mirando el celular.<br />Hace falta que tenga dónde llegar.</p>
          <a class="cta" :href="SIGNUP_URL">Probá gratis <span aria-hidden="true">↗</span> </a>
          <div class="guarantee">Sin tarjeta · Cancelás cuando quieras</div>
        </div>
      </section>
    </main>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref } from 'vue';
import { useHead } from '@unhead/vue';
import { useScrollReveal } from '@/composables/useScrollReveal';
import { useCopyVariant } from '@/composables/useCopyVariant';
import { SIGNUP_URL } from '@/constants';

const { isCopyV2 } = useCopyVariant();

useHead({
  title: 'Prio - Consultas que entran solas, y entran leídas',
  meta: [
    {
      name: 'description',
      content:
        'Recibí consultas en tu formulario público. Después del envío, la IA prepara un análisis con tu catálogo e historial para que vos revises y presupuestes.',
    },
    { name: 'theme-color', content: '#f7f3fb' },
  ],
  link: [
    { rel: 'preconnect', href: 'https://fonts.googleapis.com' },
    { rel: 'preconnect', href: 'https://fonts.gstatic.com', crossorigin: '' },
    {
      rel: 'stylesheet',
      href: 'https://fonts.googleapis.com/css2?family=Urbanist:wght@500;600;700;800;900&family=Inter:wght@400;500;600;700&family=IBM+Plex+Mono:wght@400;500&display=swap',
    },
  ],
});

// Hero raw/analyzed morph (illustrative demo).
const heroAnalyzed = ref(true);

function toggleHero(): void {
  heroAnalyzed.value = !heroAnalyzed.value;
}

// Placement switcher: same link, four placements.
type Placement = 'ig' | 'wa' | 'web' | 'mail';

const placement = ref<Placement>('ig');
const placementNotes: Record<Placement, string> = {
  ig: 'En tu bio. Te descubren y ya saben dónde consultar.',
  wa: '/presupuesto, 2 taps. La respuesta rápida la mandás vos.',
  web: 'En tu botón de presupuesto. Del sitio a tu formulario.',
  mail: 'Al pie de tus mails. Cada mail deja la puerta abierta.',
};
const placementNote = computed<string>(() => placementNotes[placement.value]);

function setPlacement(next: Placement): void {
  placement.value = next;
}

// Analysis reveal.
const formSent = ref<boolean | null>(null);
const analysisOpen = ref(false);

function toggleAnalysis(): void {
  analysisOpen.value = !analysisOpen.value;
}

// Inbox demo (states + filters + draft, nothing is sent).
type InboxState = 'new' | 'analyzed' | 'contact' | 'converted';
type InboxFilter = 'all' | InboxState;

interface InboxRow {
  name: string;
  title: string;
  detail: string;
  state: InboxState;
  initial: InboxState;
  convertDisabled: boolean;
}

const rows = ref<InboxRow[]>([
  {
    name: 'Juli',
    title: 'Juli · 8 personas',
    detail: 'City tour + traslado · Estimado $885.000',
    state: 'analyzed',
    initial: 'analyzed',
    convertDisabled: false,
  },
  {
    name: 'Nico',
    title: 'Nico · Consulta recibida',
    detail: '“Quiero organizar un recorrido en familia.”',
    state: 'new',
    initial: 'new',
    convertDisabled: false,
  },
  {
    name: 'Luz',
    title: 'Luz · Recorrido privado',
    detail: 'Consulta convertida a borrador.',
    state: 'converted',
    initial: 'converted',
    convertDisabled: true,
  },
]);
const filter = ref<InboxFilter>('all');
const draftVisible = ref(false);
const draftTitle = ref('');
const draftCopy = ref('');
const inboxFeedback = ref('Demo ilustrativa. No se envía ni se guarda nada.');

const stateLabels: Record<InboxState, string> = {
  new: 'Nueva',
  analyzed: 'Analizada',
  contact: 'Contactada',
  converted: 'Convertida',
};

function stateLabel(state: InboxState): string {
  return stateLabels[state];
}

function stateClass(state: InboxState): string {
  if (state === 'new') return 'new';
  if (state === 'contact') return 'contact';
  if (state === 'converted') return 'ok';
  return '';
}

const visibleCount = computed<number>(
  () => rows.value.filter((row) => filter.value === 'all' || row.state === filter.value).length,
);

function setFilter(next: InboxFilter): void {
  filter.value = next;
}

function convertRow(row: InboxRow): void {
  row.state = 'converted';
  row.convertDisabled = true;
  draftTitle.value = 'Borrador para ' + row.name;
  draftCopy.value =
    row.name === 'Juli'
      ? 'City tour: $720.000 + traslado: $165.000. Estimado: $885.000. Revisá fechas, aeropuerto y disponibilidad con el cliente.'
      : 'Consulta: recorrido en familia. Completá los servicios y precios antes de compartir.';
  draftVisible.value = true;
  inboxFeedback.value =
    'Demo: consulta de ' + row.name + ' convertida. El borrador espera tu revisión.';
}

function contactRow(row: InboxRow): void {
  if (row.state !== 'converted') row.state = 'contact';
  inboxFeedback.value =
    'Demo: contacto con ' +
    row.name +
    ' simulado. Usás el email o teléfono que dejó; vos escribís. No se envió nada.';
}

function resetInbox(): void {
  rows.value.forEach((row) => {
    row.state = row.initial;
    row.convertDisabled = row.initial === 'converted';
  });
  filter.value = 'all';
  draftVisible.value = false;
  inboxFeedback.value = 'Demo reiniciada. No se envía ni se guarda nada.';
}

// 24/7 count-up (client-only, honors reduced motion).
const countRef = ref<HTMLElement | null>(null);
let countDone = false;
let countObserver: IntersectionObserver | null = null;
let countRafId = 0;
let disposed = false;
let reducedMotion = false;
let mediaQuery: MediaQueryList | null = null;

function onMotionChange(): void {
  reducedMotion = mediaQuery?.matches ?? false;
}

onMounted(() => {
  mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  reducedMotion = mediaQuery.matches;
  mediaQuery.addEventListener('change', onMotionChange);
  if (!('IntersectionObserver' in window)) return;
  countObserver = new IntersectionObserver(
    (entries) => {
      if (!entries.some((entry) => entry.isIntersecting) || countDone) return;
      countDone = true;
      countObserver?.disconnect();
      const el = countRef.value;
      if (!el || reducedMotion) return;
      const start = performance.now();
      const tick = (now: number): void => {
        if (disposed) return;
        const progress = Math.min(1, (now - start) / 700);
        el.textContent = String(Math.round(24 * (1 - Math.pow(1 - progress, 3))));
        if (progress >= 1 || reducedMotion) {
          el.textContent = '24';
          return;
        }
        countRafId = requestAnimationFrame(tick);
      };
      countRafId = requestAnimationFrame(tick);
    },
    { threshold: 0.6 },
  );
  if (countRef.value) countObserver.observe(countRef.value);
});

onUnmounted(() => {
  disposed = true;
  countObserver?.disconnect();
  mediaQuery?.removeEventListener('change', onMotionChange);
  cancelAnimationFrame(countRafId);
});

useScrollReveal();
</script>

<style scoped>
/* Prototype delta: slightly deeper muted than the canonical token. */
.l3 {
  --muted: #70647d;
}
h1,
h2,
h3,
.display {
  font-family: Urbanist, Arial, sans-serif;
  font-weight: 800;
  letter-spacing: -0.045em;
  line-height: 1.04;
}
h1 {
  font-size: clamp(49px, 6.25vw, 84px);
}
h2 {
  font-size: clamp(39px, 4.7vw, 62px);
}
h3 {
  font-size: 34px;
}

a {
  color: inherit;
  text-decoration: none;
}
button {
  font: inherit;
  color: inherit;
  cursor: pointer;
}
button,
a {
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
}
button {
  border: 0;
}
button,
a {
  min-height: 44px;
}
button:disabled {
  cursor: default;
}
a:focus-visible,
button:focus-visible {
  outline: 3px solid var(--violet);
  outline-offset: 4px;
}
[hidden] {
  display: none !important;
}
.wrap {
  width: min(1180px, calc(100% - 40px));
  margin: auto;
}
.mono,
.eyebrow {
  font:
    10px/1.6 'IBM Plex Mono',
    monospace;
  letter-spacing: 0.07em;
}
.eyebrow {
  text-transform: uppercase;
  color: var(--violet);
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 22px;
}
.eyebrow:before {
  content: '';
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--pink);
  flex-shrink: 0;
}
.cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 35px;
  min-height: 56px;
  padding: 14px 24px;
  border-radius: 16px;
  background: var(--aurora);
  border: 1px solid #c6a8df;
  font-weight: 700;
  font-size: 13px;
  position: relative;
  overflow: hidden;
  isolation: isolate;
  transition: transform 0.2s var(--ease);
}
.cta:before {
  content: '';
  position: absolute;
  inset: -100%;
  background: linear-gradient(105deg, transparent 42%, #fff8 50%, transparent 58%);
  transform: translateX(-65%);
  z-index: -1;
}
.cta:hover:before {
  animation: sheen 0.8s var(--ease);
}
.cta:active,
button:active {
  transform: scale(0.98);
}
.guarantee {
  font-size: 10px;
  color: var(--muted);
  margin-top: 12px;
}
.accent {
  position: relative;
}
.accent:after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 0;
  width: 100%;
  height: 9px;
  border-top: 3px solid var(--pink);
  border-radius: 50%;
  transform: rotate(-2deg);
}
.hero {
  padding: 42px 0 55px;
  display: grid;
  gap: 36px;
  align-items: center;
}
.hero-copy > p {
  font-size: 14px;
  line-height: 1.9;
  max-width: 440px;
  margin: 28px 0 25px;
}
.hero h1 {
  max-width: 650px;
}
.hero-art {
  position: relative;
  min-width: 0;
  padding: 20px 0 0;
}
.scene {
  position: relative;
  padding: 24px 14px 18px;
  isolation: isolate;
}
.scene:before {
  content: '';
  position: absolute;
  inset: 14px 0 25px;
  background: var(--aurora);
  border-radius: 46% 54% 42% 58% / 45% 38% 62% 55%;
  opacity: 0.6;
  z-index: -2;
  transform: rotate(-9deg);
}
.scene:after {
  content: '';
  position: absolute;
  inset: 4px -2px 15px;
  border: 1px solid #c5b1de;
  border-radius: 50%;
  transform: rotate(14deg);
  z-index: -1;
}
.spark {
  position: absolute;
  right: 0;
  top: -30px;
  font-size: 66px;
  line-height: 1;
  color: var(--violet);
  transform: rotate(12deg);
}
.handnote {
  position: absolute;
  top: -14px;
  left: 5px;
  font:
    600 18px Urbanist,
    sans-serif;
  transform: rotate(-8deg);
  color: var(--violet);
}
.raw-message {
  position: relative;
  background: #fffdfc;
  border: 1px solid #d9cddd;
  border-radius: 19px 19px 19px 4px;
  padding: 17px 20px;
  max-width: 330px;
  box-shadow: 0 12px 30px #31204709;
  transform: rotate(-3deg);
  margin-bottom: 10px;
  font-size: 13px;
}
.raw-message small {
  display: block;
  text-align: right;
  color: var(--muted);
  font-size: 10px;
  margin-top: 8px;
}
.raw-message strong {
  font-weight: 600;
}
.connector {
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: var(--violet);
  font-size: 10px;
}
.connector span:first-child {
  font-size: 22px;
}
.sheet {
  background: #fffcff;
  border: 1px solid #fff;
  border-radius: 23px;
  padding: 22px;
  box-shadow: 0 20px 55px #39265013;
  position: relative;
}
.hero-sheet {
  margin-left: 17px;
  transform: rotate(2deg);
}
.sheet-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding-bottom: 15px;
  border-bottom: 1px solid var(--line);
  font-size: 11px;
}
.studio {
  font:
    800 22px Urbanist,
    sans-serif;
  letter-spacing: -1px;
}
.status {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 9px;
  font-weight: 600;
  border-radius: 20px;
  padding: 4px 9px;
  white-space: nowrap;
  background: #eee6fb;
  color: #644296;
}
.status.high,
.status.new {
  background: #fff0d3;
  color: #815010;
}
.status.new:before {
  content: '';
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #b36b0b;
}
.status.ok {
  background: #e5f5de;
  color: #22613e;
}
.status.contact {
  background: #e5eeff;
  color: #31558a;
}
.sheet-title {
  font:
    800 28px/1.1 Urbanist,
    sans-serif;
  letter-spacing: -1px;
  margin: 20px 0 14px;
}
.chips {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}
.chip {
  font-size: 10px;
  padding: 5px 9px;
  border-radius: 8px;
  background: #f0e9fa;
  color: #604b79;
}
.total {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-top: 17px;
  margin-top: 17px;
  border-top: 1px solid var(--line);
  font-size: 11px;
}
.total strong {
  font:
    800 32px Urbanist,
    sans-serif;
  letter-spacing: -1px;
}
.footnote {
  font-size: 10px;
  color: var(--muted);
  margin-top: 12px;
}
.demo-caption {
  text-align: center;
  margin-top: 17px;
  font-size: 10px;
  color: var(--muted);
}
.quiet-button {
  background: transparent;
  color: var(--violet);
  font-size: 11px;
  padding: 8px 12px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  gap: 9px;
}
.scene[data-view='raw'] .hero-sheet {
  opacity: 0;
  transform: translateY(20px) rotate(-4deg);
  pointer-events: none;
}
.scene[data-view='raw'] .connector {
  opacity: 0;
}
.hero-sheet,
.connector {
  transition:
    transform 0.6s var(--ease),
    opacity 0.45s var(--ease);
}
.scene[data-view='raw'] .raw-message {
  transform: translateY(80px) rotate(-3deg);
}
.raw-message {
  transition: transform 0.6s var(--ease);
}
.hero-controls {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex-wrap: wrap;
}
.ribbon {
  border-block: 1px solid #c7b3de;
  background: var(--aurora);
  padding: 15px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 28px;
  font:
    700 12px Urbanist,
    sans-serif;
  letter-spacing: 0.03em;
}
.ribbon span {
  color: var(--violet);
  font-size: 24px;
  line-height: 1;
}
.ribbon .desktop {
  display: none;
}
.section {
  padding: 70px 0;
}
.pain-heading {
  display: grid;
  gap: 24px;
}
.pain-heading h2 {
  max-width: 700px;
}
.pain-heading > p {
  max-width: 330px;
  font-size: 14px;
}
.stats {
  display: grid;
  margin-top: 38px;
  border-top: 1px solid var(--line);
}
.stat {
  padding: 25px 0;
  border-bottom: 1px solid var(--line);
  display: grid;
  grid-template-columns: 115px 1fr;
  gap: 18px;
  align-items: center;
}
.stat-number {
  font:
    800 51px/1 Urbanist,
    sans-serif;
  letter-spacing: -3px;
  color: var(--violet);
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}
.stat b {
  font-size: 12px;
}
.stat p {
  font-size: 11px;
  margin-top: 5px;
}
.flow {
  background: #eee7f5;
  border-block: 1px solid var(--line);
}
.flow-head {
  display: grid;
  gap: 20px;
}
.flow-head p {
  max-width: 320px;
}
.steps {
  margin-top: 35px;
}
.step {
  display: grid;
  gap: 29px;
  padding: 42px 0;
  border-top: 1px solid #d7cbe3;
  align-items: center;
  scroll-margin-top: 30px;
}
.step-copy {
  max-width: 420px;
}
.step-number {
  font:
    500 12px 'IBM Plex Mono',
    monospace;
  color: var(--violet);
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 23px;
}
.step-number:after {
  content: '';
  width: 47px;
  height: 1px;
  background: #bdabd1;
}
.step-copy h3 {
  font-size: 36px;
  max-width: 410px;
}
.step-copy p {
  margin-top: 20px;
  font-size: 13px;
  line-height: 1.9;
}
.step-copy strong {
  color: var(--ink);
  font-weight: 600;
}
.step-aside {
  display: inline-block;
  margin-top: 21px;
  font:
    600 17px Urbanist,
    sans-serif;
  color: var(--violet);
  transform: rotate(-2deg);
}
.mock-shell {
  min-width: 0;
  border: 1px solid #fff9;
  border-radius: 28px;
  background: #f7f3fb9c;
  padding: 16px;
  box-shadow: 0 16px 40px #31204706;
}
.mock-label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 13px;
  font:
    9px 'IBM Plex Mono',
    monospace;
  color: var(--muted);
  gap: 8px;
}
.switcher {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 4px;
  padding: 4px;
  background: #e8e0f0;
  border: 1px solid #d9cce5;
  border-radius: 16px;
  margin-bottom: 15px;
}
.switcher button {
  border-radius: 11px;
  background: transparent;
  font-size: 10px;
  padding: 8px 3px;
  transition:
    background 0.2s,
    color 0.2s;
}
.switcher button[aria-pressed='true'] {
  background: #fffcff;
  box-shadow: 0 3px 9px #3120470c;
  color: var(--violet);
  font-weight: 700;
}
.placement {
  min-height: 282px;
  background: #fffcff;
  border: 1px solid #e3d9ed;
  border-radius: 20px;
  overflow: hidden;
  position: relative;
}
.placement-head {
  padding: 13px 17px;
  border-bottom: 1px solid #eee7f4;
  font-size: 11px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.placement-body {
  padding: 22px;
}
.profile {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 15px;
}
.avatar {
  width: 54px;
  height: 54px;
  display: grid;
  place-items: center;
  background: var(--aurora);
  border-radius: 50%;
  font:
    800 27px Urbanist,
    sans-serif;
  border: 3px solid white;
  box-shadow: 0 0 0 1px #c6ade3;
}
.profile strong {
  font-size: 13px;
}
.profile small {
  display: block;
  font-size: 10px;
  color: var(--muted);
}
.placement p {
  font-size: 11px;
  color: var(--ink);
  line-height: 1.8;
}
.linkpill {
  display: inline-flex;
  align-items: center;
  min-height: 44px;
  max-width: 100%;
  gap: 8px;
  background: #eee7fa;
  color: var(--violet);
  border: 1px solid #dbcbed;
  border-radius: 22px;
  padding: 9px 13px;
  font-size: 11px;
  margin-top: 16px;
  overflow-wrap: anywhere;
}
.wa {
  background: #eeeee7;
}
.wa .placement-head {
  background: #fffcff;
}
.bubble {
  margin: 0 0 0 12px;
  background: #e1f0d5;
  border: 1px solid #ccdcbc;
  padding: 15px;
  border-radius: 14px 14px 3px 14px;
  font-size: 11px;
}
.bubble .linkpill {
  background: #f8fff1;
  border-color: #c2d4b4;
  color: #326243;
  padding-inline: 10px;
  font-size: 10px;
}
.bubble small {
  display: block;
  text-align: right;
  color: #607255;
  font-size: 9px;
  margin-top: 6px;
}
.shortcut {
  font:
    10px 'IBM Plex Mono',
    monospace;
  margin-bottom: 12px;
  color: #52634c;
}
.web-preview {
  text-align: center;
  background: linear-gradient(155deg, #f4e8d5, #edf0de);
}
.web-preview .studio {
  font-size: 27px;
  margin-bottom: 12px;
  display: block;
}
.web-preview h4 {
  font:
    800 27px/1 Urbanist,
    sans-serif;
  letter-spacing: -1px;
  margin: 22px 0 12px;
}
.web-preview .linkpill {
  background: var(--ink);
  color: #fff;
  border: 0;
  margin-top: 13px;
}
.email-lines {
  height: 5px;
  background: #ece6f2;
  margin-bottom: 8px;
  width: 83%;
  border-radius: 3px;
}
.email-lines.short {
  width: 54%;
  margin-bottom: 22px;
}
.signature {
  border-left: 2px solid #b99ad8;
  padding-left: 13px;
}
.signature strong {
  display: block;
  font:
    800 21px Urbanist,
    sans-serif;
}
.signature .linkpill {
  font-size: 10px;
  padding: 8px 10px;
  margin-top: 8px;
}
.placement-note {
  font-size: 10px;
  margin-top: 12px;
  color: var(--violet);
  min-height: 36px;
}
.form-sheet {
  padding: 24px 21px;
}
.form-sheet .sheet-top {
  font-size: 9px;
}
.form-sheet .sheet-title {
  font-size: 33px;
  margin-top: 23px;
}
.field {
  padding: 13px 14px;
  border: 1px solid var(--line);
  border-radius: 12px;
  font-size: 11px;
  line-height: 1.8;
  margin-top: 11px;
  background: #fbf8fd;
}
.field small {
  display: block;
  font:
    9px 'IBM Plex Mono',
    monospace;
  color: var(--muted);
  margin-bottom: 7px;
}
.clarify {
  background: #eee7fa;
  border: 1px solid #d8c8ec;
  border-radius: 13px;
  padding: 14px;
  margin-top: 14px;
  font-size: 11px;
}
.clarify strong {
  color: var(--violet);
  font-size: 10px;
}
.clarify p {
  margin-top: 6px;
  font-size: 11px;
  color: var(--ink);
}
.answer {
  margin-top: 9px;
  background: #fffcff;
  border-radius: 8px;
  padding: 8px 10px;
}
.form-end {
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  font-size: 9px;
  color: var(--muted);
}
.form-end span:last-child {
  background: var(--ink);
  color: #fff;
  padding: 9px 12px;
  border-radius: 9px;
}
.analysis-raw {
  padding: 17px;
  border-radius: 14px;
  background: #f2edf7;
  border: 1px solid var(--line);
  font-size: 12px;
  margin: 16px 0;
}
.analysis-button {
  width: 100%;
  background: var(--aurora);
  border: 1px solid #c8b1df;
  border-radius: 12px;
  min-height: 48px;
  font-size: 12px;
  font-weight: 600;
}
.analysis-result {
  margin-top: 16px;
}
.catalog-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 12px 0;
  border-bottom: 1px solid #e8dfef;
  font-size: 11px;
}
.catalog-row b {
  white-space: nowrap;
}
.suggestion {
  padding: 13px 15px;
  background: #f6f0e5;
  border-radius: 12px;
  margin-top: 17px;
  font-size: 11px;
  color: #73531f;
}
.suggestion b {
  display: block;
  font-size: 10px;
  margin-bottom: 6px;
}
.analysis-result .total {
  border: 0;
  margin-top: 0;
}
.analysis-result .footnote {
  font-size: 9px;
}
.inbox .sheet {
  padding: 18px;
}
.inbox-title {
  font:
    800 26px Urbanist,
    sans-serif;
  letter-spacing: -1px;
}
.filters {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin: 16px 0;
}
.filters button {
  font-size: 9px;
  padding: 8px;
  border: 1px solid transparent;
  border-radius: 10px;
  background: transparent;
}
.filters button[aria-pressed='true'] {
  background: #eee7fa;
  color: var(--violet);
  border-color: #d6c6e9;
}
.inbox-row {
  padding: 17px 0;
  border-top: 1px solid var(--line);
}
.row-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}
.row-head strong {
  font-size: 12px;
}
.inbox-row p {
  font-size: 10px;
  margin: 5px 0 10px;
}
.row-actions {
  display: flex;
  gap: 7px;
}
.row-actions button {
  font-size: 10px;
  padding: 9px 11px;
  border-radius: 10px;
  background: #eee7fa;
  color: var(--violet);
  border: 1px solid #d8c7eb;
}
.row-actions button:last-child {
  color: #326243;
  background: #eff5e9;
  border-color: #d3e0c7;
}
.row-actions button:disabled {
  background: #e5f5de;
  color: #22613e;
  border-color: #cddfc5;
}
.inbox-feedback {
  font-size: 10px;
  min-height: 36px;
  margin-top: 12px;
  color: var(--violet);
}
.draft {
  padding: 15px;
  border-radius: 13px;
  background: #f1f7e9;
  border: 1px solid #d1dfbf;
  margin-top: 12px;
}
.draft b {
  font-size: 11px;
}
.draft p {
  font-size: 11px;
  margin-top: 6px;
}
.empty {
  font-size: 11px;
  padding: 22px 0;
}
.trust-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 25px;
}
.trust-head h2 {
  max-width: 690px;
}
.seal {
  display: none;
  flex-shrink: 0;
  width: 112px;
  height: 112px;
  border: 1px solid #b9a2cf;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  text-align: center;
  font:
    700 17px Urbanist,
    sans-serif;
  transform: rotate(12deg);
  color: var(--violet);
}
.compare {
  display: grid;
  margin-top: 35px;
  border-block: 1px solid var(--line);
}
.compare-col {
  padding: 25px 0;
}
.compare-col + .compare-col {
  border-top: 1px solid var(--line);
}
.compare-col h3 {
  font:
    500 10px 'IBM Plex Mono',
    monospace;
  letter-spacing: 0.1em;
  color: var(--violet);
}
.compare ul {
  list-style: none;
  padding: 0;
  margin: 20px 0 0;
  display: grid;
  gap: 13px;
}
.compare li {
  font-size: 13px;
  display: flex;
  gap: 14px;
}
.compare li:before {
  content: '✓';
  color: #477235;
}
.compare-col:last-child li:before {
  content: '−';
  color: #9d6983;
}
.trust-bottom {
  margin-top: 21px;
  font-size: 12px;
}
.closing {
  padding: 75px 0 80px;
  position: relative;
  overflow: hidden;
  text-align: center;
  isolation: isolate;
  background: linear-gradient(180deg, var(--paper), #ece1f7);
}
.closing:before {
  content: '';
  position: absolute;
  width: 650px;
  height: 330px;
  left: 50%;
  top: 90px;
  transform: translateX(-50%) rotate(-12deg);
  background: var(--aurora);
  border-radius: 50%;
  z-index: -2;
  opacity: 0.47;
}
.closing:after {
  content: '';
  position: absolute;
  inset: 45px -100px 50px;
  border: 1px solid #c7b2de;
  border-radius: 50%;
  transform: rotate(-8deg);
  z-index: -1;
  pointer-events: none;
}
.closing .eyebrow {
  justify-content: center;
}
.closing h2 {
  max-width: 780px;
  margin: 0 auto;
}
.closing h2 span {
  color: var(--violet);
}
.closing p {
  margin: 25px auto;
  max-width: 370px;
  font-size: 13px;
}
.closing .cta {
  background: var(--ink);
  color: #fff;
  border-color: #564367;
}
.closing .guarantee {
  color: #675673;
}

.reveal {
  transition:
    opacity 0.65s var(--ease),
    transform 0.65s var(--ease);
}
.motion .reveal:not(.visible):not(.active) {
  opacity: 0;
  transform: translateY(22px);
}
@keyframes sheen {
  to {
    transform: translateX(65%);
  }
}
@keyframes arrive {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.arrive {
  animation: arrive 0.38s var(--ease);
}
@media (min-width: 760px) {
  .wrap {
    width: min(1180px, calc(100% - 64px));
  }
  .hero {
    grid-template-columns: 1.13fr 1fr;
    gap: 50px;
    padding: 72px 0 76px;
  }
  .hero-art {
    padding-top: 25px;
  }
  .scene {
    padding: 30px 25px 25px;
  }
  .raw-message {
    max-width: 345px;
  }
  .hero-sheet {
    margin-left: 50px;
    padding: 26px;
  }
  .spark {
    right: 0;
    top: -23px;
    font-size: 80px;
  }
  .handnote {
    left: 20px;
    font-size: 20px;
  }
  .ribbon .desktop {
    display: inline;
  }
  .ribbon {
    gap: 50px;
    font-size: 15px;
  }
  .section {
    padding: 95px 0;
  }
  .pain-heading {
    grid-template-columns: 1.55fr 1fr;
    align-items: end;
    gap: 80px;
  }
  .stats {
    grid-template-columns: repeat(3, 1fr);
    border-bottom: 1px solid var(--line);
    margin-top: 45px;
  }
  .stat {
    display: block;
    border: 0;
    padding: 28px 28px 30px 0;
  }
  .stat + .stat {
    border-left: 1px solid var(--line);
    padding-left: 35px;
  }
  .stat-number {
    font-size: 76px;
    margin-bottom: 18px;
  }
  .flow-head {
    grid-template-columns: 1.3fr 1fr;
    align-items: end;
    gap: 70px;
  }
  .flow-head p {
    justify-self: end;
  }
  .steps {
    margin-top: 55px;
  }
  .step {
    grid-template-columns: 1fr 1.15fr;
    gap: 90px;
    padding: 60px 0;
  }
  .step-copy h3 {
    font-size: 43px;
  }
  .step-copy p {
    font-size: 14px;
  }
  .mock-shell {
    padding: 23px;
  }
  .placement {
    min-height: 290px;
  }
  .placement-body {
    padding: 24px 30px;
  }
  .switcher button {
    font-size: 11px;
  }
  .placement p {
    font-size: 12px;
  }
  .form-sheet {
    padding: 27px 30px;
  }
  .form-sheet .sheet-title {
    font-size: 37px;
  }
  .field {
    font-size: 12px;
  }
  .seal {
    display: flex;
  }
  .compare {
    grid-template-columns: 1fr 1fr;
  }
  .compare-col {
    padding: 30px 0;
  }
  .compare-col + .compare-col {
    border-top: 0;
    border-left: 1px solid var(--line);
    padding-left: 45px;
  }
  .compare li {
    font-size: 15px;
  }
  .closing {
    padding: 110px 0 115px;
  }
  .closing:before {
    width: 850px;
    height: 400px;
  }
  .closing:after {
    inset: 45px 10% 50px;
  }
}
@media (prefers-reduced-motion: reduce) {
  html {
    scroll-behavior: auto;
  }
  *,
  *:before,
  *:after {
    animation: none !important;
    transition: none !important;
  }
  .motion .reveal:not(.visible):not(.active) {
    opacity: 1;
    transform: none;
  }
}
</style>
